module.exports = __webpack_public_path__ + "img/f973b6861d316d4a621c7059a0fca67f.png";